import React, {
  FC, useState,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import {
  Button,
} from './Styles';
import Header from '../../../../Common/Header';
import PlatformLayout from '../../../../Common/PlatformLayout';
import { Column } from '../../../../Common/Logo/Styles';
import SquadRegularText from '../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../components/Text/PingFangRegularText';
import SearchUser from '../SearchUser';
import DividerLine from '../../../../../../components/DividerLine';

const SelectPlatform: FC<Props> = ({
  cabId32Str,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  onClose,
  driverId,
}) => {
  // 当前选择的平台
  const [selectedPlatform, setSelectedPlatform] = useState<number>();

  return (
    <>
      {
        !selectedPlatform && (
          <>
            {/* 头部 */}
            <Header
              isEnglish={isEnglish}
              setIsEnglish={setIsEnglish}
              style={{ marginTop: '50px' }}
              supportIsOnlyCall={true}
              cabId32Str={cabId32Str}
            />

            {/* 重新开柜标题 */}
            <Column style={{ marginTop: '20px' }}>
              <Button
                style={{ position: 'absolute', left: '15px', marginTop: '2px' }}
                onClick={onClose}
              >
                <FaChevronLeft style={{ fontSize: '20px', color: '#11202B' }} />
              </Button>
              {
                isEnglish ? (
                  <div style={{ height: '30px', fontSize: '30px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '40px' }}>
                    Reopen the locker
                  </div>
                ) : (
                  <div style={{ height: '42px', fontSize: '30px', fontFamily: 'PingFangSC-Semibold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '42px' }}>
                    重新开柜
                  </div>
                )
              }
            </Column>

            {/* 分隔线 */}
            <DividerLine width={266} backgroundColor={'#11202B'} opacity={0.157} marginLeft={'auto'} marginRight={'auto'} marginTop={25} />

            {/* 标题 */}
            {
              isEnglish ? (
                <SquadRegularText fontSize={20} lineHeight={21} textAlign={'center'} marginTop={26}>
                  Select your platform
                </SquadRegularText>
              ) : (
                <PingFangRegularText fontSize={20} lineHeight={21} textAlign={'center'} marginTop={26}>
                  请选择您的配送平台
                </PingFangRegularText>
              )
            }

            {/* 商家列表 */}
            <PlatformLayout isEnglish={isEnglish} callback={setSelectedPlatform} />
          </>
        )
      }

      {
        selectedPlatform && (
          <SearchUser
            cabId32Str={cabId32Str}
            selectedPlatform={selectedPlatform}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            driverId={driverId}
            onClose={onClose}
          />
        )
      }
    </>
  );
};

export interface Props {
  cabId32Str: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  driverId: number;
  onClose: () => void;
}

export default SelectPlatform;
